/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import DiagLabInventory from './diag-lab-inventory';
import DiagLabInventoryDetail from './diag-lab-inventory-detail';
import DiagLabInventoryUpdate from './diag-lab-inventory-update';
import DiagLabInventoryDeleteDialog from './diag-lab-inventory-delete-dialog';

const DiagLabInventoryRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<DiagLabInventory />} />
    <Route path="new" element={<DiagLabInventoryUpdate />} />
    <Route path=":id">
      <Route index element={<DiagLabInventoryDetail />} />
      <Route path="edit" element={<DiagLabInventoryUpdate />} />
      <Route path="delete" element={<DiagLabInventoryDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default DiagLabInventoryRoutes;
